import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    MenuItem,
    IconButton,
    Stack,
    Typography,
} from "@mui/material"
import React, { useState } from "react"
import { Add, Delete } from "@mui/icons-material"

function ModalQuestion({ open, handleClose, handleSave }) {
    const [question, setQuestion] = useState({
        questionText: "",
        questionOptions: [], // agora é array de strings (labels)
        type: "text", // "text" | "single_select" | "multi_select"
    })

    const handleAddOption = () => {
        setQuestion({
            ...question,
            questionOptions: [...question.questionOptions, ""],
        })
    }

    const handleOptionChange = (index, value) => {
        const updatedOptions = [...question.questionOptions]
        updatedOptions[index] = value
        setQuestion({ ...question, questionOptions: updatedOptions })
    }

    const handleRemoveOption = (index) => {
        const updatedOptions = question.questionOptions.filter(
            (_, i) => i !== index,
        )
        setQuestion({ ...question, questionOptions: updatedOptions })
    }

    const handleSaveQuestion = () => {
        if (!question.questionText) return

        const formattedQuestion = {
            ...question,
            questionOptions:
                question.type === "text"
                    ? ""
                    : JSON.stringify(
                          question.questionOptions.map((label, idx) => ({
                              id: idx + 1,
                              label,
                          })),
                      ),
        }

        setQuestion({
            questionText: "",
            questionOptions: [],
            type: "text",
        })

        handleSave(formattedQuestion)
    }

    const close = () => {
        setQuestion({
            questionText: "",
            questionOptions: [],
            type: "text",
        })
        handleClose()
    }

    return (
        <Dialog open={open} onClose={close} maxWidth="md" fullWidth>
            <DialogTitle>Nova pergunta</DialogTitle>

            <DialogContent
                sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
            >
                <TextField
                    label="Texto da pergunta"
                    value={question.questionText}
                    fullWidth
                    onChange={(e) =>
                        setQuestion({
                            ...question,
                            questionText: e.target.value,
                        })
                    }
                />

                <TextField
                    select
                    label="Tipo de pergunta"
                    value={question.type}
                    onChange={(e) =>
                        setQuestion({
                            ...question,
                            type: e.target.value,
                            questionOptions: [],
                        })
                    }
                >
                    <MenuItem value="text">Resposta em texto</MenuItem>
                    <MenuItem value="single_select">Seleção única</MenuItem>
                    <MenuItem value="multi_select">Seleção múltipla</MenuItem>
                </TextField>

                {(question.type === "single_select" ||
                    question.type === "multi_select") && (
                    <>
                        <Typography variant="subtitle2">
                            Opções de resposta
                        </Typography>

                        <Stack spacing={1}>
                            {question.questionOptions.map((opt, index) => (
                                <Stack
                                    key={index}
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                >
                                    <TextField
                                        fullWidth
                                        label={`Opção ${index + 1}`}
                                        value={opt}
                                        onChange={(e) =>
                                            handleOptionChange(
                                                index,
                                                e.target.value,
                                            )
                                        }
                                    />
                                    <IconButton
                                        onClick={() =>
                                            handleRemoveOption(index)
                                        }
                                    >
                                        <Delete />
                                    </IconButton>
                                </Stack>
                            ))}
                        </Stack>

                        <Button
                            onClick={handleAddOption}
                            startIcon={<Add />}
                            sx={{ mt: 1 }}
                            size="small"
                        >
                            Adicionar opção
                        </Button>
                    </>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={close}>Fechar</Button>
                <Button onClick={handleSaveQuestion} variant="contained">
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalQuestion
